export const i18nKeyPrefix: string = 'COMPONENTS-PRICING'
